import React from 'react';
import CTA from "../../components/Constant/cta/CTA";
import WhySection from "../../components/WhySection/WhySection";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";

export default function UKNonDomiciledTaxRegime() {

    return (
        <main className='main'>
            <IntroSection
                title="UK Non-Domiciled (Non-Dom) Tax Regime"
                subtitle="Tax Benefits for Foreign Residents in the UK"
                description="The UK Non-Domiciled (Non-Dom) tax regime is one of the most advantageous systems for internationally mobile individuals. It enables residents who are not considered ‘domiciled’ in the UK to limit their taxation to UK-sourced income and gains, while foreign income remains untaxed if not remitted to the UK. This structure is ideal for entrepreneurs, global investors, and families seeking to live in the UK while maintaining international tax efficiency."
                badges={[
                    "Keep Global Income Outside UK Tax",
                    "Live & Work in the UK",
                    "Combine with UK Company Structures"
                ]}
                buttonText="Request a UK Non-Dom Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/non-dom-tax-regim/uk-non-dom.png')}
                imageAlt="UK Non-Dom Tax Regime"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Who Qualifies as Non-Dom?"
                        blocks={[
                            {
                                items: [
                                    { text: "You must be resident in the UK (more than 183 days or meet statutory residency tests)." },
                                    { text: "You must NOT be UK-domiciled (domicile refers to long-term home or origin)." },
                                    { text: "Typical applicants: entrepreneurs, HNWIs, expats, global investors." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Key Benefits of UK Non-Dom Status"
                        blocks={[
                            {
                                items: [
                                    { text: "Foreign income & gains are not taxed if not remitted to the UK." },
                                    { text: "UK income and gains taxed normally under UK tax rules." },
                                    { text: "Flexible structuring via offshore trusts, IBCs, holding companies." },
                                    { text: "Inheritance Tax Mitigation — offshore assets may be shielded from UK IHT." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="The Remittance Basis of Taxation"
                        blocks={[
                            {
                                subtitle: "How It Works",
                                items: [
                                    { text: "Non-Doms can elect to be taxed on the remittance basis." },
                                    { text: "UK tax applies only to income or gains brought into ('remitted') to the UK." },
                                    { text: "Foreign income kept offshore remains tax-free." }
                                ]
                            },
                            {
                                subtitle: "Annual Remittance Basis Charge (RBC)",
                                items: [
                                    { text: "Free during the first 7 years of UK residency." },
                                    { text: "£30,000 per year after 7 years." },
                                    { text: "£60,000 per year after 12 years." },
                                    { text: "After 15 years: deemed domiciled → worldwide taxation applies." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Practical Uses of UK Non-Dom Status"
                        blocks={[
                            {
                                items: [
                                    { title: "Protect Offshore Investments", text: "Retain foreign income tax-free while living in the UK." },
                                    { title: "Enhance Credibility", text: "Use UK companies but keep non-UK earnings outside UK tax." },
                                    { title: "Estate Planning", text: "Use offshore trusts to mitigate inheritance tax exposure." },
                                    { title: "Global Entrepreneur Benefit", text: "Live in London while optimizing international tax strategy." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Example Scenario"
                        blocks={[
                            {
                                items: [
                                    {
                                        text:
                                            "A non-dom entrepreneur lives in London and earns £100k salary (taxed in the UK). " +
                                            "Their offshore IBC generates $1M annually. As long as the foreign profits remain offshore " +
                                            "and are not remitted to the UK, no UK tax is due on the $1M."
                                    }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Considering UK residency?"
                        description="Offshore Advisory provides specialist guidance on non-dom structures, offshore trusts, and residency planning to optimize your global wealth."
                        buttonText="Book a UK Non-Dom Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long can I keep non-dom status?",
        answer: "Up to 15 years, after which you become “deemed domiciled.”",
    },
    {
        question: "Do I need to register somewhere?",
        answer: "No formal application – you claim non-dom status annually in your UK tax return.",
    },
    {
        question: "Can I still use UK banks?",
        answer: "Yes, but remitted foreign income into the UK will be taxed.",
    },
    {
        question: "What happens if I invest offshore income into UK property?",
        answer: "It counts as a remittance and becomes taxable.",
    },
];



const testimonialsData =
    [

    ]
;
